import { render, staticRenderFns } from "./FormP5.vue?vue&type=template&id=fd512b22&scoped=true"
import script from "./FormP5.vue?vue&type=script&lang=ts"
export * from "./FormP5.vue?vue&type=script&lang=ts"
import style0 from "./FormP5.vue?vue&type=style&index=0&id=fd512b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd512b22",
  null
  
)

export default component.exports